<template>
  <div class="animated fadeIn">
    <!-- <b-card no-body>
      <div slot="header" class="title_head">Send SMS
      </div>
      <b-collapse id="collapse1" visible>
        <b-card-body>
          <b-row>
            <b-col sm="12">
              <b-form-group>
                <label for="name"> Customer Name </label>
                  <b-form-input
                  id="textarea"
                  v-model="mobile_no"
                  placeholder="Enter Mobile No."
                  ></b-form-input>
                  <b-form-textarea
                  id="textarea"
                  v-model="msg"
                  placeholder="Enter something..."
                  rows="3"
                  max-rows="6"
                  ></b-form-textarea>
              </b-form-group>
            </b-col>
            <b-col sm="4" style="margin-top: 10px;">
              <button
                type="button"
                 @click.prevent="sendSms()"
                class="btn btn-pill btn-primary serach_bttn">
                Send SMS
              </button>
            </b-col>
             <b-col sm="4" style="margin-top: 10px;">
              <button
                type="button"
                class="btn btn-pill btn-primary serach_bttn" style="width: 150px;"
                @click.prevent="sendAnniWish()"
                >
                Anniversary Wish 
                
              </button>
            </b-col>
             <b-col sm="4" style="margin-top: 10px;">
              <button
                type="button"
                class="btn btn-pill btn-primary serach_bttn" style="width: 150px;"
                @click.prevent="sendBdayWish()"
                >
                Birthday Wish 
                
              </button>
            </b-col>
          </b-row>          
        </b-card-body>
      </b-collapse>
    </b-card> -->

    <div class="card-body">
        <button v-if="super_user == 1"
                      type="button"
                      class="btn btn-sm btn-primary label_bttn"
                      @click.prevent="addscheme()"
                    >
                      <i class="fa fa-plus"></i> Add SMS
                    </button>
                     <label for="name">SMS Status </label>
              &nbsp;&nbsp;&nbsp;<label
                class="switch switch-text switch-pill switch-primary"
                 v-if="super_user == 1"
                ><input
                
                  type="checkbox"
                  data-toggle="tooltip"
                  data-placement="top"
                  title=""
                  data-original-title="Tooltip on top"
                  class="switch-input"
                  v-on:change="sms_status"
                  :true-value="true"
                  :false-value="false"
                  v-model="active_deactive" disabled />
                <span
                  data-on="Active"
                  data-off="Deactive"
                  class="switch-label"
                ></span>
                <span class="switch-handle"></span
              ></label>
            <vue-good-table
              mode="remote"
              ref="my-table"
            
              :totalRows="totalRecords"
              :columns="columns4"
              :rows="rows4"
              :pagination-options="{
                enabled: true,
                perPage: 5,
              }"
              styleClass="vgt-table striped bordered table-sm condensed"
            >
              <template slot="table-row" slot-scope="props">
                <span v-if="props.column.field == 'action'">
                  
                  <!-- <i
                    class="fa fa-eye"
                    @click="viewCard(props.row)"
                    style="color: #63c2de; font-size: 20px; cursor: pointer;"
                  ></i> -->
                  <span >
                     <i
                      class="fa fa-pencil"
                      style="color: #63c2de; font-size: 20px; cursor: pointer;"
                      title="Edit Scheme"
                      v-on:click="editScheme(props.row)"
                    ></i>
                    <i
                      class="fa fa-trash-o"
                      style="color: #f44336; font-size: 20px; cursor: pointer;"
                      title="Delete"
                      v-on:click="removeScheme(props.row)"
                    ></i>
        

                    <!-- <router-link :to="{ name: 'Edit Purchase', params: { purchaseId: props.row.purchase_id, shopId: props.row.est_shop_id }}"> -->
                   
                    <!-- </router-link> -->
                    <!--<a @click="editpro2(props.row)" style="color:#63c2de;font-size: 20px; cursor: pointer;">Return</a>-->
                  </span>
                  <!-- <span v-else>
                    <i
                      class="fa fa-trash"
                      style="color: grey !important; font-size: 20px;"
                    ></i>
                    <i
                      class="fa fa-pencil"
                      style="color: grey !important; font-size: 20px;"
                    ></i>
                   <a style="color:grey !important;font-size: 20px;">Return</a>
                  </span> -->
                </span>
                <span v-else-if="props.column.field == 'gst_total'">
                  {{
                    (
                      parseFloat(props.row.cgst_amt) +
                      parseFloat(props.row.sgst_amt) +
                      parseFloat(props.row.igst_amt)
                    ).toFixed(2)
                  }}
                </span>

               
                <span v-else-if="props.column.field == 'return'">
                  <span v-if="pur_rights === true">
                    <i
                      class="fa fa-reply"
                      style="color: #63c2de; font-size: 18px; cursor: pointer;"
                      v-on:click="editpro2(props.row)"
                    ></i>
                  </span>
                  <span v-else>
                    <i
                      class="fa fa-reply"
                      style="color: grey !important; font-size: 18px;"
                    ></i>
                  </span>
                </span>
                <span v-else>
                  {{ props.formattedRow[props.column.field] }}
                </span>
              </template>
            </vue-good-table>
          </div>
         
          <div class="card-body">
             <span><h3>Today's Birthday And Anniversaries</h3></span>
            <vue-good-table
              mode="remote"
              ref="my-table"
            
              :totalRows="totalRecords"
              :columns="columns3"
              :rows="rows3"
              :pagination-options="{
                enabled: true,
                perPage: 5,
              }"
              styleClass="vgt-table striped bordered table-sm condensed"
            >
              <template slot="table-row" slot-scope="props">
                
                <span v-if="props.column.field == 'action'">
                  
                  <!-- <i
                    class="fa fa-eye"
                    @click="viewCard(props.row)"
                    style="color: #63c2de; font-size: 20px; cursor: pointer;"
                  ></i> -->
                  <span >
                     <i
                      class="fa fa-pencil"
                      style="color: #63c2de; font-size: 20px; cursor: pointer;"
                      title="Edit Scheme"
                      v-on:click="editScheme(props.row)"
                    ></i>
                    <i
                      class="fa fa-trash-o"
                      style="color: #f44336; font-size: 20px; cursor: pointer;"
                      title="Delete"
                      v-on:click="removeScheme(props.row)"
                    ></i>
        

                    <!-- <router-link :to="{ name: 'Edit Purchase', params: { purchaseId: props.row.purchase_id, shopId: props.row.est_shop_id }}"> -->
                   
                    <!-- </router-link> -->
                    <!--<a @click="editpro2(props.row)" style="color:#63c2de;font-size: 20px; cursor: pointer;">Return</a>-->
                  </span>
                  <!-- <span v-else>
                    <i
                      class="fa fa-trash"
                      style="color: grey !important; font-size: 20px;"
                    ></i>
                    <i
                      class="fa fa-pencil"
                      style="color: grey !important; font-size: 20px;"
                    ></i>
                   <a style="color:grey !important;font-size: 20px;">Return</a>
                  </span> -->
                </span>
                <span v-else-if="props.column.field == 'gst_total'">
                  {{
                    (
                      parseFloat(props.row.cgst_amt) +
                      parseFloat(props.row.sgst_amt) +
                      parseFloat(props.row.igst_amt)
                    ).toFixed(2)
                  }}
                </span>
                <span v-else-if="props.column.field == 'birth_date'">
                    <span v-if="newDate(props.row.birth_date) == '01-01-1970'"> </span>
                    <span v-else>{{ newDate(props.row.birth_date) }} </span>
                </span>
                  <span v-else-if="props.column.field == 'anniversary_date'">
                    <span v-if="newDate(props.row.anniversary_date) == '01-01-1970'"> </span>
                  <span v-else>{{ newDate(props.row.anniversary_date) }} </span>
                </span>
               
                <span v-else-if="props.column.field == 'return'">
                  <span v-if="pur_rights === true">
                    <i
                      class="fa fa-reply"
                      style="color: #63c2de; font-size: 18px; cursor: pointer;"
                      v-on:click="editpro2(props.row)"
                    ></i>
                  </span>
                  <span v-else>
                    <i
                      class="fa fa-reply"
                      style="color: grey !important; font-size: 18px;"
                    ></i>
                  </span>
                </span>
                <span v-else>
                  {{ props.formattedRow[props.column.field] }}
                </span>
              </template>
            </vue-good-table>
          </div>
           <b-modal :title="tit" no-close-on-esc no-close-on-backdrop size="lg" class="modal-info" hide-footer v-model="largeModal" @ok="largeModal = false">
      <b-row>
          <b-col sm="4">
              <b-form-group>
                <label for="name"> SMS Sender </label>
                <b-form-input
                  type="text"
                  placeholder="Enter Sender Name"
                  autocomplete="off"
                  v-model="cardData.sendername"
                ></b-form-input>
                <small  class="form-text text-muted"><strong style="color: red;">{{hasErrors.sendername}}</strong></small>
              </b-form-group>
            </b-col>
            <b-col sm="4">
              <b-form-group>
                <label for="name"> Template Id </label>
                <b-form-input
                  type="text"
                  placeholder="Enter Template Id"
                  autocomplete="off"
                  v-model="cardData.templateid"
                ></b-form-input>
                 <small  class="form-text text-muted"><strong style="color: red;">{{hasErrors.templateid}}</strong></small>
              </b-form-group>
            </b-col>
             <b-col sm="4">
              <b-form-group>
                <label for="name"> Sms Category </label>
                <b-form-input
                  type="text"
                  placeholder="Enter Category"
                  autocomplete="off"
                  v-model="cardData.smscat"
                  disabled
                ></b-form-input>
                 <small  class="form-text text-muted"><strong style="color: red;">{{hasErrors.smscat}}</strong></small>
              </b-form-group>
            </b-col>
      </b-row>
      <b-row>
          <b-col sm="4">
              <b-form-group>
                <label for="name"> Sender Mobile No.</label>
                <b-form-input
                  type="text"
                  placeholder="Enter Sender Mobile number"
                  autocomplete="off"
                  v-model="cardData.sendermobile"
                ></b-form-input>
                <small  class="form-text text-muted"><strong style="color: red;">{{hasErrors.sendermobile}}</strong></small>
              </b-form-group>
            </b-col>
            <b-col sm="4">
              <b-form-group>
                <label for="name"> Access Token </label>
                <b-form-input
                  type="text"
                  placeholder="Enter Access Token"
                  autocomplete="off"
                  v-model="cardData.access_token"
                ></b-form-input>
                 <small  class="form-text text-muted"><strong style="color: red;">{{hasErrors.templateid}}</strong></small>
              </b-form-group>
            </b-col>
             <b-col sm="4">
              <b-form-group>
                <label for="name"> Share Link </label>
                <b-form-input
                  type="text"
                  placeholder="Share the link here"
                  autocomplete="off"
                  v-model="cardData.sharedlink"
                ></b-form-input>
                 <small  class="form-text text-muted"><strong style="color: red;">{{hasErrors.smscat}}</strong></small>
              </b-form-group>
            </b-col>    
                </b-col>
            <b-col sm="12">
              <b-form-group>
                <label for="name">Template Message </label>
                <b-form-input
                  type="text"
                  placeholder="Enter Template Message"
                  autocomplete="off"
                  v-model="cardData.templatemsg"
                ></b-form-input>
                 <small  class="form-text text-muted"><strong style="color: red;">{{hasErrors.templatemsg}}</strong></small>
              </b-form-group>
            </b-col>       
      </b-row>
      <div class="card-footer modal_footer">
        <b-row>
          <b-col sm="12">
            <b-button-group>
              <b-button class="d-sm-down-none btn-sm" v-if="saveBtn" @click.prevent="cardScheme()" variant="primary"><i class="fa fa-dot-circle-o"></i> Save</b-button>
               <b-button class="d-sm-down-none btn-sm" v-if="editBtn" @click.prevent="editSchemedata()" variant="primary"><i class="fa fa-dot-circle-o"></i> Edit</b-button>
            </b-button-group>
          </b-col>
        </b-row>
      </div>
    </b-modal>
    <Spinner v-if="loading"></Spinner>
  </div>
</template>


<style>
.switch.switch-text .switch-label::before,
.switch.switch-text .switch-label::after {
  width: 67% !important;
}
.switch.switch-text {
  width: 74px;
}
.switch.switch-text .switch-input:checked ~ .switch-handle {
  left: 50px;
}
.switch.switch-text .switch-label {
  background-color: red;
}
.selected_row {
  background-color: blue;
}
.modal-title {
  color: black;
  font-weight: bold;
}
</style>
<script>
export default {
  data() {
    return {
         super_user: 3,
        smsStatus:'',
        largeModal: false,
      loading: false,
      msg_id:'',
      totalRecords: 0,
        cardData:{
          sendername:'',
          sendermobile:'',
          access_token:'',
          sharedlink:'',
          templateid:'',
          templatemsg:'',
          smscat : '',
         
        },
         active_deactive: '',
         hasErrors:{
          sendername:'',
          templateid:'',
          templatemsg:'',
          sendermobile:'',
          access_token:'',
          sharedlink:'',
           smscat:'',
        },
      tit:'',
      saveBtn:false,
      editBtn:false,
      mobile_no:'',
      msg:'',
      rows4: [],
        columns4: [
        {
          label: "SMS Category",
          field: "sms_category",
          width: "10% !important",
          tdClass: "text-left",
          thClass: "text-left",
        },
        {
          label: "SMS Sender",
          field: "sms_sender",
          width: "10% !important",
          tdClass: "text-left",
          thClass: "text-left",
        },
        {
          label: "Template Id",
          field: "sms_template_id",
          width: "15% !important",
          tdClass: "text-left",
          thClass: "text-left",
        },
        {
          label: "Message",
          field: "sms_template",
          width: "20% !important",
          tdClass: "text-left",
          thClass: "text-left",
        },
        {
          label: "Sender mobile No",
          field: "sender_mob",
          width: "10% !important",
          tdClass: "text-left",
          thClass: "text-left",
        },
        {
          label: "Access Token",
          field: "sms_access_token",
          width: "20% !important",
          tdClass: "text-left",
          thClass: "text-left",
        },
        {
          label: "Shared Link",
          field: "share_link",
          width: "25% !important",
          tdClass: "text-left",
          thClass: "text-left",
        },
        {
          label: "Action",
          field: "action",
          width: "10% !important",
          thClass: "text-center",
          tdClass: "text-center",
        },
      ],
       rows3: [],
        columns3: [
       {
          label: "Customer Name",
          field: "cust_cmp_name",
          width: "10% !important",
          tdClass: "text-left",
          thClass: "text-left",
        },
        {
          label: "Birth Date",
          field: "birth_date",
          type: "date",
          dateInputFormat: "YYYY-MM-DDThh:mm:ss",
          dateOutputFormat: "Do MMM YYYY",
          tdClass: "text-left",
          thClass: "text-left",
          width: "15% !important",
        },
         {
          label: "Anniversary Date",
          field: "anniversary_date",
          type: "date",
          dateInputFormat: "YYYY-MM-DDThh:mm:ss",
          dateOutputFormat: "Do MMM YYYY",
          tdClass: "text-left",
          thClass: "text-left",
          width: "15% !important",
        },
        {
          label: "Mobile No.",
          field: "cust_cmp_phone",
          width: "15% !important",
           tdClass: "text-left",
          thClass: "text-left",
        },
         {
          label: "Email",
          field: "cust_cmp_email",
          width: "15% !important",
            tdClass: "text-left",
          thClass: "text-left",
        },
        ],
    }
  },
  created(){
     var _this = this;
    //this.customerCards();
     this.goldScheme();
     this.upcomingBday();
      this.super_user = _this.$store.getters.get_super_user;
  },
  methods:{
    deactivate_acc() {
      var _this = this;
      this.loading = true;
      let res = {
        sms_status: _this.smsStatus,
      };
      this.$http
        .post("/api/users/update", res)
        .then(function (response) {
          if (response.status === 200) {
            // alert("your account has been deactivated");
            _this.loading = false;
            localStorage.clear();
          
          }
        })
        .catch(function (error) {
          _this.loading = false;
          localStorage.clear();
       
        });
    },

    sms_status() {
    
    if(this.active_deactive==false){
      this.smsStatus=false
    }else{
        this.smsStatus=true
    }
     this.deactivate_acc()
     
    },
     goldScheme(){
       
      var _this=this
      this.$http.get('/api/goldsms/schemecard') .then(function (response) {
        _this.rows4 =response.data
        console.log(_this.rows4 )
        _this.active_deactive = response.data[0].sms_status
        console.log(_this.active_deactive)
        
      })
      .catch(function (error) {

      });
    },
     upcomingBday(){
      var _this=this
      this.$http.get('/api/customers/upcomingbirthdayAnni') .then(function (response) {
        _this.rows3 =response.data
      })
      .catch(function (error) {

      });
    },
      addscheme(){
            this.reset();
            //  this.hasErrors.schemename=false
            //  this.hasErrors.monthlypay=false
            //  this.hasErrors.schememonths=false
            this.saveBtn = true
            this.editBtn = false
            this.tit = "Add SMS"
            this.largeModal = true
            
          },
           cardScheme(){ 
        var _this = this
        this.submit_true=0;
      if (this.submit_true==0){
           this.loading=true
          //this.largeModal=false;
             if(_this.cardData.sendername==null || _this.cardData.sendername=='' ){
              _this.loading=false;
            this.hasErrors.sendername="Please Enter Sender Name"
          }else if(_this.cardData.templateid  ==null || _this.cardData.templateid==''){
               _this.loading=false;
              _this.hasErrors.senderid="Please Enter Template Id"
              }else if(_this.cardData.smscat  ==null || _this.cardData.smscat ==''){
               _this.loading=false;
              _this.hasErrors.smscat ="Please Enter Category"
              }else if(_this.cardData.templatemsg  ==null || _this.cardData.templatemsg ==''){
               _this.loading=false;
              _this.hasErrors.templatemsg ="Please Enter Template Message"
              }else if(_this.cardData.access_token  ==null || _this.cardData.access_token ==''){
               _this.loading=false;
              _this.hasErrors.access_token ="Please Enter Access token"
              }else{
                 var user=null;
            _this.submitschemevalue(_this)
            
              }
         
             }
          },
          submitschemevalue(_this){
              
                      let res = {
                          sms_sender:this.cardData.sendername,
                          sms_template_id:this.cardData.templateid,
                          sms_template:this.cardData.templatemsg, 
                          sms_category:this.cardData.smscat,  
                          sender_mob:this.cardData.sendermobile,   
                          sms_access_token:this.cardData.access_token,
                          share_link:this.cardData.sharedlink,        
                        }
                  console.log('s'+res)
                this.$http.post('/api/goldsms', res)
                .then(function (response) {
               console.log(response)
                  
               if(response.status==200){
                _this.message = true
                 _this.message = "SMS Added Successfully"
                 _this.largeModal = false;
                 alert("SMS Added Successfully")
                 setTimeout(function(){ _this.message='';}, 2000);
                 _this.loading=false;
                  _this.goldScheme();
                   console.log('error')
                // _this.getTotals();
                  _this.reset();
                
               }else{
                console.log('error')
               }
            
                })
                  .catch(function (error) {
                    _this.loading=false
                    console.log(error)
                  });

            },
    editScheme(schemeid){
      this.reset();
      this.saveBtn = false
      this.editBtn = true
      this.tit = "Edit SMS"
      this.largeModal = true
      this.cardData.sendername = schemeid.sms_sender
      this.cardData.templateid = schemeid.sms_template_id
      this.cardData.templatemsg = schemeid.sms_template
      this.cardData.smscat = schemeid.sms_category
      this.cardData.sendermobile = schemeid.sender_mob
      this.cardData.access_token = schemeid.sms_access_token
      this.cardData.sharedlink = schemeid.share_link
       this.msg_id = schemeid.id
     
    },
    editSchemedata(){ 
          var _this = this        
          this.submit_true=0;
         
          if (this.submit_true==0){
          this.loading=true
          //this.largeModal=false;
           if(_this.cardData.sendername==null || _this.cardData.sendername=='' ){
              _this.loading=false;
            this.hasErrors.sendername="Please Enter Sender Name"
          }else if(_this.cardData.templateid  ==null || _this.cardData.templateid==''){
               _this.loading=false;
              _this.hasErrors.senderid="Please Enter Template Id"
              }else if(_this.cardData.smscat  ==null || _this.cardData.smscat ==''){
               _this.loading=false;
              _this.hasErrors.smscat ="Please Enter Category"
              }else if(_this.cardData.templatemsg  ==null || _this.cardData.templatemsg ==''){
               _this.loading=false;
              _this.hasErrors.templatemsg ="Please Enter Template Message"
              }else{
                 var user=null;
            _this.submitschemevalue1(_this)
              }
             }
          },
          submitschemevalue1(_this){
             console.log('as')
              let res = {
                          sms_sender:this.cardData.sendername,
                          sms_template_id:this.cardData.templateid,
                          sms_template:this.cardData.templatemsg, 
                          sms_category:this.cardData.smscat,
                          sms_access_token:this.cardData.access_token,
                          sender_mob:this.cardData.sendermobile,
                          share_link:this.cardData.sharedlink             
                        }
               this.$http.post('/api/goldsms/update?where[id]='+this.msg_id, res)
                .then(function (response) {            
                if(response.status==200){
                _this.message = true
                 _this.message = "SMS Edited Successfully"
                 _this.largeModal = false;
                 alert("SMS Edited Successfully")
                 setTimeout(function(){ _this.message='';}, 2000);
                 _this.loading=false;
                  _this.goldScheme();
                
               }else{
                console.log('error')
               }
            
                })
                  .catch(function (error) {
                    _this.loading=false
                    console.log(error)
                  });

            },
    reset(){
      this.cardData.sendername = ''
      this.cardData.templateid = ''
      this.cardData.templatemsg = ''
      this.cardData.sendermobile = ''
      this.cardData.access_token = ''
      this.cardData.sharedlink = ''
    
      this.hasErrors.sendername = ''
      this.hasErrors.templateid = ''
      this.hasErrors.templatemsg = ''
      this.hasErrors.sendermobile = ''
      this.hasErrors.access_token = ''
      this.hasErrors.sharedlink = ''
    },
     newDate(date1) {
      var dt1 = new Date(date1);
      var year = dt1.getFullYear();
      var month = dt1.getMonth() + 1;
      var day = dt1.getDate();
      if (day < 10) {
        day = "0" + day;
      }
      if (month < 10) {
        month = "0" + month;
      }
      var dt2 = day + "-" + month + "-" + year;
      // var dt2 = year+'-'+month+'-'+day
      return dt2;
    },
    sendSms(){ 
      var _this=this
      var mob=this.mobile_no 
      var sms = this.msg
      
    var url="https://sms.businesskarma.in/api/v2/sms/send?access_token=7adfb2b85bb817ff6d38f027b79ed167&message="+sms+"&sender=YSFHHS&to=91"+mob+"&service=T";

     this.$http
        .get(url).then(function (response) {
        //console.log(url);
        //  console.log(response);
      })
      .catch(function (error) {
       // console.log(error);
      });
    console.log(mob+"-"+sms)
    },
    sendAnniWish(){ 
        var _this=this
      var mob=this.mobile_no 
      var sms = this.msg

      this.$http.get('/api/customers/anniversarymobileNo') .then(function (response) {
           for (var i = 0; i < response.data.length; i++) { 
           console.log("Anniversary : "+response.data[i]);
      //      var url="https://sms.businesskarma.in/api/v2/sms/send?access_token=7adfb2b85bb817ff6d38f027b79ed167&message="+sms+"&sender=YSFHHS&to=91"+response.data[i].cust_cmp_phone+"&service=T";
      //  _this.$http
      //   .get(url).then(function (data) {
      //   console.log(url);
      //     console.log(data);
      // })
      // .catch(function (error) {
      //   console.log(error);
      // });
       }
      })
      .catch(function (error) {
      });
    },
    sendBdayWish(){ 
        var _this=this
      var mob=this.mobile_no 
      var sms = this.msg

      this.$http.get('/api/customers/birthdaymobileNo') .then(function (response) {
           for (var i = 0; i < response.data.length; i++) { 
           console.log("Birthday:"+response.data[i].cust_cmp_phone);
      //      var url="https://sms.businesskarma.in/api/v2/sms/send?access_token=7adfb2b85bb817ff6d38f027b79ed167&message="+sms+"&sender=YSFHHS&to=91"+response.data[i].cust_cmp_phone+"&service=T";
      //  _this.$http
      //   .get(url).then(function (data) {
      //   console.log(url);
      //     console.log(data);
      // })
      // .catch(function (error) {
      //   console.log(error);
      // });
       }
      })
      .catch(function (error) {
      });
    },
    getTotals(val){    
            if(val === 'comp'){
                if(this.tfrst_time === false){
                  this.tfrst_time = true
                }
                else{
                  return
                }
              }
            var _this=this
            localStorage.removeItem("customer_id");
            let filteParam = {};
            filteParam.page = this.serverParams.page;
            filteParam.perPage = this.serverParams.perPage;
            filteParam.sort = this.serverParams.sort;
            var data=[];
            this.rows=[];
            this.loading = true
            var customer_id = JSON.parse(localStorage.getItem('customer_id'));
             // console.log(customer_id)
            var data = "&filter[where][customer_id]=" + customer_id;
            this.$http.get('/api/customercards/showCards?params='+JSON.stringify(filteParam)+data)
                    .then(function(response){
                    //  _this.totalRecords = response.data[0].totalRecords;
                     // response.data.shift()
                      if(response.data != undefined)
                      _this.rows4=  response.data;
                      _this.loading = false
                      console.log(response.data)
                   
                      }).catch(function(error){
                  console.log(error)
              })
            },
  },
}
</script>



// WEBPACK FOOTER //
// src/views/gold/sendsms.vue